import React from 'react';
import { AccountApiResponse, CommonPageStep, ThankyouPageStep } from '..';
import * as qs from 'query-string';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { ThankYouElement } from './ThankYouElement';
import { DesktopView } from './desktop/ThankYou.desktop';
import { MobileView } from './mobile/ThankYou.mobile';
import apiHelper, {
  SupportedIncomingFormat,
  SupportedMethod,
  SupportedOutgoingFormat,
  SupportedServers,
} from '../../common/ApiHelper';
import {
  disableBrowserBackFunction,
  parseParamAndFetchSupscription,
  resumeUserSession,
} from '../../common/CommonTools';
import { appConfig } from '../../common/ConfigLoader';
import { useAppSelector } from '../../store/hooks';
import {
  AppStateAuthentication,
  selectAppAuthentication,
  selectAppPageStep,
  selectAppStateData,
  setAppPageStep,
  updateAppAuthentication,
  updateAppUserProfile,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export const Thankyou = (): JSX.Element => {
  // Redux Hooks
  const authenticationData = useAppSelector(selectAppAuthentication);
  const pageStep = useAppSelector(selectAppPageStep);
  const appState = useAppSelector(selectAppStateData);

  // ELEMENT
  const thankYouElement = ThankYouElement();

  // Page functions
  const storeUserSessionInfo = (): void => {
    const sessionInfoString = JSON.stringify({ ...authenticationData });
    window.localStorage.setItem('bigbang_session_info', sessionInfoString);
  };

  const loadUserProfile = async (): Promise<void> => {
    await apiHelper(
      SupportedServers.ACCOUNT,
      'user/UserProfile',
      SupportedMethod.POST,
      {},
      {
        incomingFormat: SupportedIncomingFormat.JSON,
        outgoingFormat: SupportedOutgoingFormat.JSON,
        headerConstructor() {
          return {
            authorization: authenticationData ? authenticationData.token : '',
          };
        },
      },
    ).then((res): void => {
      if (res.success && res.data) {
        outsideComponentDispatch(updateAppUserProfile(res.data));
        console.log(
          res.data.parentProfile.profile_data.accountAttributes?.isInitialized,
        );
      }
    });
  };

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ThankyouPageStep.THANK_YOU));
    parseParamAndFetchSupscription();

    // DISABLE BACK BUTTON
    disableBrowserBackFunction(window);
  }, []);

  React.useEffect(() => {
    // LOAD PAYMENT RECORD
    if (authenticationData) {
      void thankYouElement.getPaymentInfoViaPaymentId(authenticationData);
      void loadUserProfile();
    }
  }, [authenticationData]);

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
      {authenticationData && pageStep === CommonPageStep.CHILD_PROFILE ? (
        <Navigate to={`/ChildProfile`} />
      ) : null}
    </React.Fragment>
  );
};
